import React from 'react';
import SharedFoundation from '../components/SharedFoundation';
import { useDocTitle } from '../components/CustomHook';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import IntroVoiceVerse from '../components/IntroVoiceVerse';
import Portfolio from '../components/Portfolio';
import Services from '../components/Services';


const Home = () => {
    useDocTitle("MCN Technologies | Audio, Video & Multimodal AI");
    return (
        <>
            <Hero />
            <SharedFoundation />
            <Services />
            <Intro />
            <IntroVoiceVerse />
            <Portfolio />
            <Cta/>
            <Footer />
        </>

    )
}

export default Home;

